import { Component, OnInit } from '@angular/core';
import { FormControl, Validators ,FormGroup,FormBuilder} from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../../auth/auth.service';
import { ClientServiceService } from "../../../shared/client-service.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  forgotPassword: FormGroup;
  submitted = false;
  returnUrl: string;
  error: {errorTitle:"",errorDesc:""};
  loginError: string;

  submittingForm: boolean = false;
  formSubmitted: boolean = false;
  formResult: boolean = false;
  formResultMessage: string = '';
  submitClicked: boolean = false;

  constructor(private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    public restApi: ClientServiceService
  ) { }

  ngOnInit(): void 
  {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      remember_me: false
    });

    this.forgotPassword = this.fb.group({
      email: ['', Validators.required]
    });

    this.authService.logout();

    this.loadRememberedUserPass();
  }

  loadRememberedUserPass()
  {
    if (localStorage.getItem('seoTunerSalesUsername')) 
    {
      this.loginForm.controls['username'].setValue(localStorage.getItem('seoTunerSalesUsername'));
    }

    if (localStorage.getItem('seoTunerSalesPassword')) 
    {
      this.loginForm.controls['password'].setValue(localStorage.getItem('seoTunerSalesPassword'));
    }
  }

  saveUserPass(username, password)
  {
    localStorage.setItem('seoTunerSalesUsername', username);
    localStorage.setItem('seoTunerSalesPassword', password);
  }

  get username() { return this.loginForm.get('username'); }
  get password() { return this.loginForm.get('password'); }

  get email() { return this.forgotPassword.get('email'); }
  
  onSubmit() 
  {
    this.submitted = true;
    if (this.loginForm.get('remember_me').value)
    {
      this.saveUserPass(this.username.value, this.password.value);
    }

    this.authService.login(this.username.value, this.password.value).subscribe((data) => 
    {
      console.log(localStorage.getItem('seocurrentUser'));
      if (this.authService.isLoggedIn()) 
      {
        console.log("logging success");
        const redirect = '/';
        //const redirect = '/';
        window.location.href = redirect;
      } 
      else 
      {
        this.loginError = data.message;
      }
    },
    error => this.error = error
    );
  }

  resetPasswordEmail()
  {
    this.submitClicked = true;
    if (this.forgotPassword.valid) 
    {
      this.restApi.resetPasswordEmail(this.email.value).subscribe((data) => 
      {
        this.submitClicked = false;
        this.formSubmitted = true;
        this.formResult = data.success;
        this.formResultMessage = data.message;
      },
      error => this.error = error
      );
    }
  }

}
